<app-leveltwo [pageId]="2">
  <div class="General">

      <h3>{{'Housing.SearchTitle'|translate}}</h3>

      <h4>{{'Housing.Housingforqualified'|translate}}</h4>
      <p>{{'Housing.Thisexemption'|translate}}</p>

      <h4>{{'Housing.Low-Income'|translate}}</h4>

      <p>{{'Housing.Housingforlow'|translate}}</p>
      <p>{{'Housing.Propertiesmay'|translate}}</p>

      <ul>
        <li>{{'Housing.Theproperty'|translate}}</li>
        <li>{{'Housing.Theowner'|translate}}</li>
        <li>{{'Housing.Propertiesowned'|translate}}</li>
      </ul>

      <p>{{'Housing.Additional'|translate}} <a href="#">{{'Housing.BOE'|translate}}</a> {{'Housing.orthe'|translate}} <a href="#">{{'Housing.Majorex'|translate}}</a> {{'Housing.forthese'|translate}}</p>

      <h4>{{'Housing.Elderlyor'|translate}}</h4>
      <p><a href="#">{{'Housing.Section214'|translate}}</a> {{'Housing.Provides'|translate}} <a href="#">{{'Housing.BOE'|translate}}</a> {{'Housing.orthe'|translate}} <a href="#">{{'Housing.Majorex'|translate}}</a>.</p>




  </div>
</app-leveltwo>
